import { useEnum } from "@/api/services/global/enum";
import { InnerBox } from "@/components/elements/InnerBox";
import { TalentInfoItem } from "@/features/talent/components/talent-detail/TalentInfoItem";
import { TTalentForm } from "@/features/talent/types/talentForm";
import { black, divider } from "@/theme/colors";
import { FCC } from "@/types/common";
import { findLabelByValue } from "@/utils/object";
import { Stack, Typography, Grid } from "@mui/material";

type TTalentRecruitmentStatusProps = {
  defaultValues?: Partial<TTalentForm>;
};

export const TalentRecruitmentStatus: FCC<TTalentRecruitmentStatusProps> = ({ defaultValues }) => {
  const { data: recruitmentStatusOptions } = useEnum("ERecruitmentStatus");

  return (
    <InnerBox p={3} showDivider={false} borderColor={divider.high} bordered={true}>
      <Stack alignItems="flex-start">
        <Typography variant="head20Bold" color={black[30]}>
          ステータス状況
        </Typography>

        <Grid mt={1} container spacing={2}>
          <Grid item xs={6}>
            <TalentInfoItem
              isShowDivider={false}
              label="求職活動ステータス"
              value={findLabelByValue(recruitmentStatusOptions, defaultValues?.recruitmentStatus)}
            />
          </Grid>

          <Grid item xs={6}>
            <TalentInfoItem label="人材担当者" value={defaultValues?.personInCharge?.fullName} isShowDivider={false} />
          </Grid>
        </Grid>
      </Stack>
    </InnerBox>
  );
};
